import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext } from "@insite/client-framework/Components/ProductContext";
import Zone, { OwnProps } from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsViewStyles {
    imageWrapper?: InjectableCss;
    productDescriptionWrapper?: InjectableCss;
    pdpActionWrapper?: InjectableCss;
    productInfoWrapper?: InjectableCss;
    container?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps & HasProductContext) => {
    return {
        addingProductToCart: state.context.addingProductToCart,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasProductContext;

export const viewStyles: ProductDetailsViewStyles = {
    container: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            [data-test-selector="LocationAvailability"] {
                max-width: 100%;
                flex-basis: 100%;
                .LocationGrid {
                    width: 50%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding-right: 15px;
                            `,
                            css`
                                padding-right: 15px;
                            `,
                            css`
                                padding-right: 15px;
                            `,
                            null,
                            null,
                        ])}
                }
                .availabilityGrid {
                    width: 50%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            null,
                            css`
                                margin-left: 30px;
                            `,
                            null,
                        ])}
                }
            }
        `,
    },
    imageWrapper: {
        css: css`
            flex-basis: 33%;
            padding: 20px 30px 30px 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        padding: 10px;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    productDescriptionWrapper: {
        css: css`
            flex-basis: 38%;
            padding: 20px 15px 20px 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        padding: 10px;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    pdpActionWrapper: {
        css: css`
            flex-basis: 28%;
            padding: 20px 15px 20px 15px;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        padding: 10px;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    productInfoWrapper: {
        css: css`
            flex-basis: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 10px;
                    `,
                    css`
                        margin: 10px;
                    `,
                    css`
                        margin: 10px 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    loadingOverlay: {
        css: css`
            & div[class^="SpinnerWrapper"] {
                position: fixed;
            }
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<Props> = props => {
    return (
        <>
            <LoadingOverlay
                loading={props.addingProductToCart !== undefined ? props.addingProductToCart : false}
                {...styles.loadingOverlay}
                spinnerProps={{ color: "primary" }}
            >
                <StyledWrapper {...styles.container}>
                    <StyledWrapper {...styles.imageWrapper}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.productDescriptionWrapper}>
                        <Zone contentId={props.id} zoneName="Content1" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.pdpActionWrapper}>
                        <Zone contentId={props.id} zoneName="Content2" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.productInfoWrapper}>
                        <Zone contentId={props.id} zoneName="Content3" />
                    </StyledWrapper>
                </StyledWrapper>
            </LoadingOverlay>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
